module.exports = __webpack_public_path__ + "img/Middle-Semi-Elliptical-Attachment-L-27.7566b0ae.png";